"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xLicense = require("@ori-ui/mui-bundle/x-license");
// license expiration date: 2025-06-21

const applyLicense = () => _xLicense.LicenseInfo.setLicenseKey('fa9ebc3177a975c21f99f994d2823f89Tz05MTUwNCxFPTE3NTA1MjE2MDAwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=');
var _default = exports.default = applyLicense;
//# sourceMappingURL=applyLicense.js.map